import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl } from '../../../../../Containers/Config';

import { CREATE_SPIN_GAME, CREATE_SPIN_GAME_SUCCESS, CREATE_SPIN_GAME_ERROR } from '../../../actionType';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../../Containers/Helpers/constant';

function* createSpinGame({ payload }) {
  console.log('createSpinGame payload', payload);
  try {
    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/create-spin-game-request`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },

      data: payload?.data,
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: CREATE_SPIN_GAME_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: CREATE_SPIN_GAME_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_SPIN_GAME_ERROR, payload: error });
  }
}

export function* watchCreateSpinGame() {
  yield takeEvery(CREATE_SPIN_GAME, createSpinGame);
}

function* createSpinGameSaga() {
  yield all([fork(watchCreateSpinGame)]);
}

export default createSpinGameSaga;
